<template>
  <div class="json-editor" ref="editorContainer">
    <CodeEditor
      v-model:value="code"
      language="json"
      :theme="currentTheme"
      :options="editorOptions"
      :height="height"
      :width="width"
      @mount="handleMount"
    />
  </div>
</template>

<script>
import { CodeEditor } from 'monaco-editor-vue3';
import * as monaco from 'monaco-editor';

export default {
  name: 'JsonEditor',
  components: {
    CodeEditor,
  },
  props: {
    theme: {
      type: String,
      default: 'vs-dark',
    },
    modelValue: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: '400px',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      code: this.modelValue,
      currentTheme: this.theme,
      editor: null,
      editorOptions: {
        fontSize: 14,
        minimap: { enabled: false },
        automaticLayout: true,
        scrollBeyondLastLine: false,
        wordWrap: 'on',
        formatOnPaste: true,
        formatOnType: true,
        tabSize: 2,
      },
    };
  },
  watch: {
    code(newValue) {
      this.$emit('update:modelValue', newValue);
    },
    modelValue(newValue) {
      if (newValue !== this.code) {
        this.code = newValue;
      }
    },
    theme: {
      handler(newTheme) {
        this.currentTheme = newTheme;
        this.updateTheme(newTheme);
      },
      immediate: false,
    },
  },
  methods: {
    handleMount(editor) {
      this.editor = editor;
      this.$nextTick(() => {
        editor.layout();
      });
    },
    updateTheme(theme) {
      // Use Monaco's global setTheme to update all editors
      monaco.editor.setTheme(theme);
    },
  },
};
</script>

<style scoped>
.json-editor {
  height: v-bind(height);
  width: v-bind(width);
  min-height: 200px;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
}
</style>
